define('Geolocation',['underscore','jquery','site_vars','js-cookie'],function(_,$,site_vars,Cookies){

    var loading = false,
        navigator = window.navigator;

    var geolocation_position_cookie_value = Cookies.get('geolocation_position') || false;

    // store value in cookie
    if(geolocation_position_cookie_value){
        try{
            geolocation_position_cookie_value = JSON.parse(geolocation_position_cookie_value);
        }catch (e) {}
    }

    var Geolocation = function (callback){

        //if(loading) return loading;
        loading = true;

        function GeolocationFail(error){
            loading = false;
            if(error){
                callback(error);
            }else{
                callback(new Error('geolocation not available'))
            }
        }

        if(navigator.permissions){
            navigator.permissions.query({name:'geolocation'}).then(function(result) {
                var state = result.state;
                if (state === 'granted') {
                    getCurrentPosition();
                } else if (state === 'prompt') {
                    getCurrentPosition();
                } else if (state === 'denied') {
                    GeolocationFail(state);
                }
            });
        }else{
            getCurrentPosition();
        }

        function getCurrentPosition() {
            if (navigator.geolocation) {
                try {
                    navigator.geolocation.getCurrentPosition(function (position) {
                        loading = false;
                        var latLng = {
                            latitude: position.coords.latitude,
                            longitude: position.coords.longitude
                        };
                        callback(false, latLng, position);
                        Cookies.set('geolocation_position', JSON.stringify(latLng), {expires: 1});
                    }, GeolocationFail,{
                        timeout:3000,
                        maximumAge:60,
                        enableHighAccuracy:true
                    });
                } catch (err) {
                    GeolocationFail(err);
                }
            } else {
                GeolocationFail()
            }
        }
    }
    Geolocation.cookiePosition = geolocation_position_cookie_value;
    return Geolocation;

});
